import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CoreStateService } from '@app/core/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-card-location',
  templateUrl: './card-location.component.html',
  styleUrls: ['./card-location.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardLocationComponent implements OnInit {
  public school$: Observable<any>;

  constructor(private coreStateService: CoreStateService) {}

  public ngOnInit() {
    this.school$ = this.coreStateService.school$;
  }

  public locationMap(school: any): string {
    return `https://maps.google.com/maps?q=${school.latitude},${school.longitude}&z=16&output=embed`;
  }
}
